<template>
    <div class="site-main mt20">
    	<div class="video-wrap">
			<div class="hd" ref="tabSlide">
				<ul class="swiper-wrapper">
					<li v-for="(item , index) in childId" class="swiper-slide" :key="item.id">
						<a href="javascript:;" @click="tabswitch(item.id,index)" :class='{active:index==current}'>{{item.name}} </a>
					</li>
				</ul>
			</div>
			<div class="bd">
				<list mold="video" :items="events" class=" b-shadow mb20"></list>
				<infinite-loading @infinite="onInfinite" ref="infiniteLoading" v-show="control == false">
		      		<span slot="no-more">我是有底线的</span>
		    	</infinite-loading>
		    	<div class="more-btn" @click="loadMore" v-show="control == true">
		    		<img src="../common/images/more-icon.png" alt="加载更多">
		    	</div>
			</div>
    	</div>
    </div>
</template>

<script>
import list from '../components/List.vue';
import {httpHead,apiUrl,setSEO} from '../common/util/config.js'
import InfiniteLoading from 'vue-infinite-loading'
import Swiper from 'swiper'
export default {
    data () {
        return {
        	events: [],
        	childId: [],
        	page: 0,
        	totalPage: 0,
        	cid: 8,
        	current: 0,
        	control: false,
        	pageSeo: {}
        }
    },
    created () {
    	let postData = this.$qs.stringify({
			    'cid': this.cid
		});
		let url = apiUrl + 'api/lists'
    	this.$axios({
    			method: 'post',
			    url: url,
			    headers: httpHead,
			    data: postData
    	})
            .then(res => {
            	this.childId = res.data.data.type[2].data
            	this.pageSeo = res.data.data.seo;
                setSEO(this.pageSeo);
            })
            .catch(err => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    },
    mounted () {
    	this.$nextTick(function () {
    		 new Swiper(this.$refs.tabSlide, {
    		  slidesPerView: 'auto',
      		  observer: true,
              observeParents: true,
              freeMode: true
		    });
    	})
    },
    methods: {
    	tabswitch (data,index) {
    		this.current = index
    		this.cid = data;
    		this.page = 0;
    		this.events = [];
    		this.$nextTick(() => {
		        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		    });
    	},
    	onInfinite ($state) {
    		let postData = this.$qs.stringify({
			    'cid': this.cid
			});
			this.page++;
			let url = apiUrl + 'api/lists/page/' + this.page
    		this.$axios({
    			method: 'post',
			    url: url,
			    headers: httpHead,
			    data: postData
    		})
	        	.then(res => {
	        		this.totalPage = res.data.data.list.last_page;
	                this.events = this.events.concat(res.data.data.list.data);
	                if (this.page > 2) {
	                	this.control = true;
	                }
	                if (this.control == false) {
	                	$state.loaded();
	                }
	                if (this.totalPage == this.page) {
	                	$state.complete();
	                }
	            })
	            .catch(err => {
	                if (err.response) {
	                    console.log(err.response)
	                    $state.complete()
	                }
	            })
	    },
	    loadMore () {
	    	this.control = false;
	    	this.$nextTick(() => {
		        this.$refs.infiniteLoading.attemptLoad();
		    });
	    }
    },
    components: {
    	list,
    	InfiniteLoading
    }
}
</script>
<style lang="scss">
	.video-wrap{
		.list{
			padding: 0 .3rem;
		}
		.hd{
			height: .8rem;line-height: .8rem;
			text-align: center;
			border-bottom: 1px solid #f29316;
			overflow: hidden;
			background: #fff;
			.swiper-slide{
				width: auto;
				padding:0 .4rem;
				a{
					color: #333;
					font-size:.26rem;
					&.active{
						color: #f29316;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/videoView.vue